import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-all-independence-declaration',
  templateUrl: './my-all-independence-declaration.component.html',
  styleUrls: ['./my-all-independence-declaration.component.css']
})
export class MyAllIndependenceDeclarationComponent implements OnInit {

  constructor(private router:Router) { }

  ngOnInit(): void {
  }

  PostAssignClick(){
    this.router.navigate(['dashboard/my-annual']);
  }

  clientDeclaClick(){
    this.router.navigate(['dashboard/my-client']);
  }

  employeeJoinClick(){
    this.router.navigate(['dashboard/my-employee']);
  }

  annualDeclaClick(){
    this.router.navigate(['dashboard/my-all-client']);
  }

  dpdpDeclarationClick(){
    this.router.navigate(['dashboard/my-dpdp-declaration']);
  }
}
